import { lazy } from "react";

// layouts
const ProductosLayout = lazy(() => import("../../productos/ProductosLayout.jsx"));
const StockProductosLayout = lazy(() => import("../../stock/ProductosLayout.jsx"));
const KardexLayout = lazy(() => import("../../kardex/KardexLayout.jsx"));

// páginas
const TipoUnidadLayout = lazy(() => import("../../tipo_unidad/TipoUnidadLayout.jsx"));
const UnidadLayout = lazy(() => import("../../unidad/UnidadLayout.jsx"));
const Productos = lazy(() => import("../../productos/Productos.jsx"));
const ProductoForm = lazy(() => import("../../productos/ProductoForm.jsx"));
const CategoriasList    = lazy(() => import("../../productos/categorias/MantenedorCategorias.jsx"));
const AtributosList     = lazy(() => import("../../productos/atributos/MantenedorAtributos.jsx"));
const MantenedorModificadores = lazy(() => import("../../productos/modificadores/MantenedorModificadores.jsx"));
const MantenedorPromociones = lazy(() => import("../../productos/promociones/MantenedorPromociones.jsx"));
const Kardex = lazy(() => import("../../kardex/Kardex.jsx"));
const TrazabilidadPrecios = lazy(() => import("../../productos/TrazabilidadPrecios.jsx"));
const ProductoDashboardLayout = lazy(() => import("../../indicadores/ProductoDashboardLayout.jsx"));
const InventoryCenter = lazy(() => import("../../inventory/InventoryCenter.jsx"));
const TomaDeStock = lazy(() => import("../../stock/TomaDeStock.jsx"));

const productosRoutes = [
      {
            path: "catalogo",
            element: <ProductosLayout />,
            children: [
                  { index: true, element: <Productos /> },
                  { path: "nuevo", element: <ProductoForm /> },
                  { path: "editar/:token", element: <ProductoForm /> },
                  { path: "trazabilidad", element: <TrazabilidadPrecios /> },
            ],
      },
      {
            path: "productos/categorias",
            element: <CategoriasList />,
      },
      {
            path: "productos/atributos",
            element: <AtributosList />,
      },
      {
            path: "productos/modificadores",
            element: <MantenedorModificadores />,
      },
      {
            path: "productos/promociones",
            element: <MantenedorPromociones />,
      },
      {
            path: "stock",
            element: <StockProductosLayout />,
      },
      {
            path: "stock/toma",
            element: <TomaDeStock />,
      },
      {
            path: "catalogo/tipo-unidad",
            element: <TipoUnidadLayout />,
      },
      {
            path: "catalogo/unidad",
            element: <UnidadLayout />,
      },
      {
            path: "kardex/:token",
            element: <KardexLayout />,
            children: [{ index: true, element: <Kardex /> }],
      },
      {
            path: "catalogo/dashboard/:token",
            element: <ProductoDashboardLayout />,
      },
      {
            path: "inventory/:token",
            element: <InventoryCenter />,
      },
];

export default productosRoutes;